import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { mainBookImage } from "../data/landingContent";
export function ProductSpotlight() {
  const reduceMotion = useReducedMotion();
  return <motion.div className="relative mx-auto flex w-full max-w-[520px] items-center justify-center py-5" initial={reduceMotion ? false : {
    opacity: 0,
    y: 16,
    scale: 0.96
  }} whileInView={reduceMotion ? undefined : {
    opacity: 1,
    y: 0,
    scale: 1
  }} viewport={{
    once: true,
    amount: 0.25
  }} transition={{
    duration: 0.8,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-288" data-mp="2zf3cctgklccl">
      <motion.div aria-hidden="true" className="absolute bottom-[9%] h-5 w-[54%] rounded-full bg-black/25 blur-md" animate={reduceMotion ? undefined : {
      opacity: [0.16, 0.1, 0.16],
      scaleX: [1, 0.9, 1]
    }} transition={{
      duration: 5,
      delay: 0.8,
      ease: "easeInOut",
      repeat: Infinity
    }} data-id="element-289" data-mp="3j2sxihu04ecu" />
      <motion.img src={mainBookImage} alt="Portada del material digital Fórmula Emprendedora" className="relative z-10 w-[80%] max-w-[450px] drop-shadow-[0_20px_28px_rgba(0,0,0,0.28)]" animate={reduceMotion ? undefined : {
      y: [0, -5, 0]
    }} transition={{
      duration: 5,
      delay: 0.8,
      ease: "easeInOut",
      repeat: Infinity
    }} data-id="element-290" data-mp="1srob15xeer89" />
    </motion.div>;
}